import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Image } from "@/components/ui/image";

const MACRO_IMG = "https://media.base44.com/images/public/6a80a7f0e10008ea488688fc/87a96b331_generated_a82a2a1e.png";

const points = [
  "Where it is applied.",
  "How the treatment is performed.",
  "Whether the property was properly prepared.",
  "Whether the treatment is appropriate for the situation.",
  "What happens afterward."
];

export default function Philosophy() {
  return (
    <section className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHeader
            kicker="Treatment Philosophy"
            title={<>WE DON'T SELL A BOTTLE.<br />WE DELIVER A TREATMENT.</>}
            subtitle="A professional treatment isn't simply about what product is being used. It's about:"
          />
          <ul className="mt-8 space-y-3">
            {points.map((p, i) => (
              <Reveal as="li" key={p} delay={i * 0.04} className="flex items-center gap-3 border-b border-border py-3 text-foreground">
                <span className="font-heading text-xs font-bold text-accent tnum">0{i + 1}</span>
                <span className="text-base">{p}</span>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.2}>
            <div className="mt-10 border-l-2 border-accent pl-6">
              <p className="font-heading text-2xl font-extrabold tracking-tight text-primary sm:text-3xl">THE CHEMICAL IS A TOOL.</p>
              <p className="font-heading text-2xl font-extrabold tracking-tight text-accent sm:text-3xl">THE TREATMENT IS THE SERVICE.</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-primary">
            <Image src={MACRO_IMG} alt="Macro view of a professional treatment applicator nozzle" fittingType="fill" className="absolute inset-0 h-full w-full" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <span className="text-[10px] font-semibold uppercase tracking-[0.28em] text-white/50">Applied with precision</span>
              <p className="mt-2 font-heading text-lg font-bold text-white">Targeted application, not broadcast spraying.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}